import { IS_NON_PROD, NORMALIZED_STAGE, STAR_GRID_DEPLOYED_API_BASE_URL } from 'src/constants/EnvironmentConstants';
import { resolveStarGridApiBaseUrl } from 'src/components/star-grid/utils/starGridApiBaseUrl';

/** StarGrid API base URL per stage (matches the ACM/Route 53 domains in StarGrid-ServiceCDK). */
const API_BASE_URL_BY_STAGE: Record<string, string> = {
  alpha: 'https://alpha.api.stargrid.device.finance.amazon.dev',
  beta: 'https://beta.api.stargrid.device.finance.amazon.dev',
  prod: 'https://api.stargrid.device.finance.amazon.dev'
};

// Non-production resolves to alpha above, which also bounds the permitted personal API hostnames.
export const STAR_GRID_API_BASE_URL = resolveStarGridApiBaseUrl(
  API_BASE_URL_BY_STAGE[NORMALIZED_STAGE] ?? API_BASE_URL_BY_STAGE.alpha,
  IS_NON_PROD,
  process.env.STAR_GRID_API_BASE_URL || STAR_GRID_DEPLOYED_API_BASE_URL
);

/** Existing reports omitted from the simplified report selection UI. */
/** Route prefix of the report engine endpoints. */
export const REPORT_ENGINE_PREFIX = '/report-engine';

/** Route prefix of the dataset-onboarding endpoints (same auth as the report engine). */
export const DATASETS_PREFIX = '/datasets';

/** StarGrid sub-views, selected via the in-page side navigation; `report` shows `activeReportId`. */
export type StarGridView =
  | 'home'
  | 'infra'
  | 'create-report'
  | 'modify-report'
  | 'manage-reports'
  | 'snapshot-manager'
  | 'report'
  | 'onboard-dataset';

/** Virtual dimension key for calculated P&L statement lines (Operating Income, etc.). */
export const PNL_STATEMENT_LINE_DIMENSION = 'pnl_statement_line';
/** The second identifying column of a two-dimension report (`Line Item + Cost Center`). */
export const PNL_SECONDARY_LINE_DIMENSION = 'pnl_secondary_line';

/** Column carrying each rollup row's root→ancestor tree path, delimited (see the API). */
export const PNL_ROLLUP_PATH_COLUMN = 'path';
export const PNL_ROLLUP_PATH_DELIMITER = ' || ';

/** Backend scenario routing for months before a forecast starts. */
export const PNL_ACTUALS_SCENARIO_ID = 1112;

/** Maximum page size supported by the version catalog API. */
export const PNL_VERSION_PAGE_SIZE = 1000;

/** Deck and screen catalogs change only on an admin edit, which clears the reuse as any write does. */
export const CATALOG_MAX_AGE_MS = 5 * 60_000;
